/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const GithubFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12 2a10 10 0 0 0-3.16 19.49c.5.09.69-.21.69-.48l-.02-1.86c-2.5.46-3.16-.61-3.36-1.17-.11-.3-.6-1.18-1.02-1.42-.35-.18-.85-.65-.02-.66.8-.01 1.35.72 1.54 1.03.9 1.5 2.34 1.08 2.91.82a2 2 0 0 1 .64-1.34c-2.22-.25-4.55-1.11-4.55-4.94A4 4 0 0 1 6.68 8.8a3.6 3.6 0 0 1 .1-2.65s.83-.26 2.75 1.02a9.3 9.3 0 0 1 5 0c1.9-1.3 2.75-1.02 2.75-1.02.55 1.37.2 2.4.1 2.65a4 4 0 0 1 1.02 2.69c0 3.83-2.34 4.68-4.56 4.93.36.32.67.91.67 1.85v2.75c0 .26.18.58.68.48A10.02 10.02 0 0 0 12 2" />
  </Icon>
);
